<template>
		<v-card @mouseenter="hover = true"
				@mouseleave="hover = false"
				:to="`/project/${project._id}`"
				class="cards">
			<v-btn v-if="hover" transition="fade-transition" class="mx-2 remove-button" fab small color="secondary"
				   @click.prevent="showConfirmDeleteDialog = true">
				<v-icon>delete</v-icon>
			</v-btn>
			<div>
				<h3 class="text--secondary headline mb-0">{{ project.name }}</h3>
			</div>
			<confirm-delete-dialog v-model="showConfirmDeleteDialog"
								   :body="$t('confirm-delete.body-subject', {subject: project.name})"
								   @remove="removeProject"></confirm-delete-dialog>
		</v-card>
</template>

<script>
	import ConfirmDeleteDialog from '@/components/dialogs/confirm-delete-dialog';

	export default {
		name: 'ProjectListItem',
		components: { ConfirmDeleteDialog },
		props: {
			project: {
				type: Object,
			}
		},
		data() {
			return {
				hover: false,
				showConfirmDeleteDialog: false,
			};
		},
		methods: {
			removeProject() {
				this.$emit('removeProject', this.project._id);
			}
		}
	};
</script>

<style lang="scss" scoped>
	@import "@/styles/colors";

	.cards {
		background-color: $background-grey !important;
		border-radius: 10px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		width: 250px;
		height: 250px;
		margin: 10px;
		text-align: center;

		&:hover {
			background-color: $light-grey !important;
		}
	}

	.remove-button {
		position: absolute;
		top: 5px;
		right: 5px;
	}
</style>
